export default "__VITE_ASSET__CbZiwo4H__"